import React, { useEffect } from 'react';
import './video-player.scss';
import ReactPlayer from 'react-player';
import useStore from '../../../customHooks/useStore';

function VideoPlayer(props) {
  const { language } = useStore((state) => ({
    language: state.language,
  }));

  const videoId = language === 'es' ? props.source.es : props.source.en;
  const videoUrl =
    typeof videoId === 'number' || /^\d+$/.test(String(videoId))
      ? `https://vimeo.com/${videoId}`
      : videoId;

  useEffect(() => {
    if (props.setVideoWatched) {
      props.setVideoWatched(false);
    }
  }, []);

  console.log('props', props.source);

  return (
    <>
      <ReactPlayer
        url={videoUrl}
        controls={true}
        width='100%'
        height='100%'
        onEnded={() => {
          if (props.setVideoWatched) {
            props.setVideoWatched(true);
          }
        }}
      />
    </>
  );
}

export default VideoPlayer;
